/* eslint-disable import/no-cycle */
import * as connectedReactRouter from 'connected-react-router'
import * as modals from '../../../constants/modals'
import routes from '../../../config/routes'
import * as types from './types'
import * as integration from '../../../integration'
import * as auth from '../auth'
import * as session from '../session'
import * as alerts from '../alerts'
import * as modal from '../modal'

export const ERROR_MESSAGES = {
  Default: {
    messages: ['Erro ao redefinir senha']
  }
}

// Error

export const receiveUsersError = (error = {}) => {
  const { name } = error

  const err = ERROR_MESSAGES[name] || ERROR_MESSAGES.Default

  const newError = {
    hasError: true,
    messages: err?.messages
  }

  return {
    type: types.RECEIVE_USERS_ERROR,
    payload: newError
  }
}

// General users

export const fetchUsers = (value = true) => ({
  type: types.FETCH_USERS,
  payload: value
})

export const receiveUsers = (data) => ({
  type: types.RECEIVE_USERS,
  payload: data
})

// Reset Password  Sent Email

export const fetchResetPasswordSentEmail = (value = true) => ({
  type: types.FETCH_USERS_RESET_PASSWORD_SENT_EMAIL,
  payload: value
})

export const receiveResetPasswordSentEmail = (data) => ({
  type: types.RECEIVE_USERS_RESET_PASSWORD_SENT_EMAIL,
  payload: data
})

export const resetPasswordSentEmail = (data, route) => async (dispatch) => {
  const { email } = data

  dispatch(fetchResetPasswordSentEmail())

  try {
    const res =
      await integration.resources.users.requests.resetPasswordSentEmail({
        email
      })

    const newRoute = route || routes.resetPasswordSentEmailFeedback.path

    dispatch(receiveResetPasswordSentEmail(email))
    dispatch(connectedReactRouter.routerActions.push(newRoute))

    return res
  } catch (err) {
    dispatch(fetchResetPasswordSentEmail(false))
    dispatch(receiveUsersError(err))

    return Promise.reject(err)
  }
}

export const resetPasswordResentEmail = () => (dispatch, getState) => {
  const email = getState()?.usersReducer?.content?.resetPassword?.email
  const route = routes.resetPasswordResentEmailFeedback.path

  dispatch(resetPasswordSentEmail({ email }, route))
}

// Pre Reset Password

export const fetchPreResetPassword = (value = true) => ({
  type: types.FETCH_USERS_RESET_PASSWORD,
  payload: value
})

export const receivePreResetPassword = (data) => ({
  type: types.RECEIVE_USERS_RESET_PASSWORD,
  payload: data
})

export const preResetPassword = (id, token, data) => async (dispatch) => {
  const { password, passwordConfirmation } = data

  const newData = {
    password,
    passwordConfirmation
  }

  dispatch(fetchPreResetPassword())

  try {
    const res = await integration.resources.users.requests.preResetPassword(
      id,
      token,
      newData
    )

    dispatch(auth.actions.receiveAuthSLT(res?.headers['x-slt']))

    dispatch(
      receivePreResetPassword({
        id,
        confirmToken: token,
        passwords: newData,
        status: res?.data?.status
      })
    )
    dispatch(
      connectedReactRouter.routerActions.push(routes.resetPasswordAuth.path)
    )

    return res
  } catch (err) {
    dispatch(fetchPreResetPassword(false))
    dispatch(receiveUsersError(err))

    return Promise.reject(err)
  }
}

// Reset Password

export const resetPassword = (data) => async (dispatch, getState) => {
  dispatch(fetchUsers())

  const slt = dispatch(auth.actions.getAuthSLT())

  const { id, passwords, status } =
    getState()?.usersReducer?.content?.resetPassword

  const { password, passwordConfirmation } = passwords

  const newData = {
    password,
    passwordConfirmation,
    code: data?.code
  }

  try {
    const res = await integration.resources.users.requests.resetPassword(
      id,
      slt,
      newData
    )

    const FIRST_ACCESS_STATUS_ID = 4

    dispatch(receiveUsers())
    dispatch(
      connectedReactRouter.routerActions.push(
        status === FIRST_ACCESS_STATUS_ID
          ? routes.registerSuccessFeedback.path
          : routes.resetPasswordSentPasswordFeedback.path
      )
    )

    return res
  } catch (err) {
    dispatch(fetchUsers(false))
    dispatch(receiveUsersError(err))
    dispatch(auth.actions.receiveError())

    return Promise.reject(err)
  }
}

export const resentResetPassword = () => (dispatch, getState) => {
  const { id, confirmToken, passwords } =
    getState()?.usersReducer?.content?.resetPassword

  dispatch(preResetPassword(id, confirmToken, passwords))
}

// Register User

export const RECEIVE_REGISTER_REDIRECT_URLS = {
  cnpj: routes.registerCNPJ.path,
  email: routes.registerEmail.path,
  phone: routes.registerPhone.path,
  password: routes.registerPassword.path
}

export const registerUserReceiveData = (data, routeType) => (dispatch) => {
  const route = RECEIVE_REGISTER_REDIRECT_URLS[routeType]

  dispatch({
    type: types.RECEIVE_USERS_REGISTER_DATA,
    payload: data
  })

  if (route) {
    dispatch(connectedReactRouter.routerActions.push(route))
  }
}

export const registerUserReceiveUserId = (id) => ({
  type: types.RECEIVE_USERS_REGISTER_ID,
  payload: id
})

export const registerUser = () => async (dispatch, getState) => {
  dispatch(fetchUsers())

  const { data } = getState().usersReducer.content.registerUser

  try {
    const res = await integration.resources.users.requests.registerUser(data)

    const { id, slt } = res?.data

    dispatch(registerUserReceiveUserId(id))
    dispatch(auth.actions.receiveAuthSLT(slt))
    dispatch(
      connectedReactRouter.routerActions.push(routes.registerPhoneConfirm.path)
    )
    dispatch(receiveUsers())

    return res
  } catch (err) {
    dispatch(fetchUsers(false))
    dispatch(
      alerts.actions.receiveAlert({
        title: 'Erro no cadastro',
        message:
          'Uma ou mais informações que você forneceu não puderam ser confirmadas. Realize seu cadastro novamente.',
        action: 'default'
      })
    )

    return Promise.reject(err)
  }
}

export const registerUserReceiveDataAndRegister = (data) => [
  registerUserReceiveData(data),
  registerUser()
]

export const registerUserRequirements =
  (requirements = [], route) =>
  (dispatch, getState) => {
    let requirementsError = false

    const store = getState().usersReducer.content.registerUser.data

    requirements.forEach((requirement) => {
      if (!store[requirement]) requirementsError = true
    })

    if (requirementsError) {
      dispatch(connectedReactRouter.routerActions.push(route))
    }
  }

// Register Confirmation

export const receiveResentDatas = (id, credentials) => [
  registerUserReceiveUserId(id),
  registerUserReceiveData(credentials)
]

export const confirmUserPhone = (data) => async (dispatch, getState) => {
  dispatch(fetchUsers())

  const slt = dispatch(auth.actions.getAuthSLT())

  const store = getState()?.usersReducer?.content?.registerUser || {}

  const { id, data: { email, password } = {} } = store

  const newData = {
    email,
    password,
    code: data?.code
  }

  try {
    const res = await integration.resources.users.requests.confirmUserPhone(
      id,
      slt,
      newData
    )

    dispatch(receiveUsers())

    dispatch(
      connectedReactRouter.routerActions.push(
        `${routes.registerEmailConfirm.path}?email=${email}`
      )
    )

    return res
  } catch (err) {
    dispatch(fetchUsers())
    dispatch(receiveUsersError(err))
    dispatch(auth.actions.receiveError(err))

    return Promise.reject(err)
  }
}

export const confirmUserPhoneResent = () => async (dispatch, getState) => {
  dispatch(fetchUsers())

  const store = getState()?.usersReducer?.content?.registerUser

  const { email, password } = store?.data

  try {
    const res = await dispatch(
      session.actions.preLogin({
        email,
        password
      })
    )

    dispatch(receiveUsers())
    dispatch(modal.actions.receiveModal(modals.AUTH_RESENT_MODAL_ID))

    return res
  } catch (err) {
    dispatch(fetchUsers(false))

    return Promise.reject(err)
  }
}

export const receiveResentDatasAndConfirmUserPhone = (id, credentials) => [
  receiveResentDatas(id, credentials),
  connectedReactRouter.routerActions.push(routes.registerPhoneConfirm.path)
]

export const confirmUserEmail = (id, token) => async (dispatch) => {
  dispatch(fetchUsers())

  try {
    const res = await integration.resources.users.requests.confirmUserEmail(
      id,
      token
    )

    dispatch(
      connectedReactRouter.routerActions.push(
        routes.registerEmailConfirmSuccess.path
      )
    )

    return res
  } catch (err) {
    dispatch(fetchUsers(false))

    dispatch(
      connectedReactRouter.routerActions.push(
        routes.registerEmailConfirmFail.path
      )
    )

    return Promise.reject(err)
  }
}

export const confirmUserEmailResent = () => async (dispatch, getState) => {
  dispatch(fetchUsers())

  const store = getState()?.usersReducer?.content?.registerUser

  const { email, password } = store?.data

  try {
    const res = await dispatch(
      session.actions.preLogin({
        email,
        password
      })
    )

    dispatch(receiveUsers())
    dispatch(
      alerts.actions.receiveAlert({
        title: 'Reenviamos o e-mail!',
        message: `Reenviamos o link de confirmação de cadastro para o e-mal ${email}`
      })
    )

    return res
  } catch (err) {
    dispatch(fetchUsers(false))

    dispatch(
      alerts.actions.receiveAlert({
        title: 'Erro ao reenviar email',
        message: 'Tente novamente'
      })
    )

    return Promise.reject(err)
  }
}

export const receiveResentDatasAndConfirmUserEmail = (id, credentials) => [
  receiveResentDatas(id, credentials),
  connectedReactRouter.routerActions.push(
    `${routes.registerEmailConfirm.path}?email=${credentials.email}`
  )
]
